import { forwardRef, type MouseEventHandler } from 'react';

import { Heart } from '@phosphor-icons/react/dist/ssr';
import classnames from 'classnames';

import type { PostLikesData } from '@/types';

export type LikeButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  data: PostLikesData;
  iconSize?: number;
  styles?: any;
  onClick?: MouseEventHandler;
  buttonType: HTMLButtonElement['type'];
};

export const LikeButton = forwardRef<HTMLButtonElement, LikeButtonProps>(
  ({ data, styles, onClick, buttonType, iconSize = 20, 'aria-label': ariaLabel }, ref) => {
    return (
      <button
        ref={ref}
        type={buttonType}
        onClick={onClick}
        className={classnames('flex justify-center', styles?.button)}
        aria-label={ariaLabel}
      >
        <Heart size={iconSize} weight={data?.isLiked ? 'fill' : undefined} />
        {data?.likesCount || ''}
      </button>
    );
  },
);
